var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.testimonies.length)?_c('div',{staticClass:"b-testimonials"},[_c('card-grid',{attrs:{"cards":_vm.data.testimonies,"slider":false,"card-type":"testimonial"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }